<div class="edg-box-header">
  <div class="date prev" (click)="prev()">
    <div>
      <mat-icon class="icon">keyboard_arrow_left</mat-icon>
      {{prevMonth}}
    </div>
  </div>
  <div class="date curr" (click)="current()">
    <div>{{currMonth}}</div>
  </div>
  <div class="date next" (click)="next()">
    <div>
      {{nextMonth}}
      <mat-icon class="icon">keyboard_arrow_right</mat-icon>
    </div>
  </div>
</div>
<div class="edg-wrap-dow">
  <div *ngFor="let title of weekTitles">
    <p class="desc">{{title}}</p>
  </div>
</div>
<div class="edg-wrap-days" [ngClass]="{five: isFiveWeeks, six: isSixWeeks}">
  <div calendar-day class="day" #calendarDay
    *ngFor="let day of days"
    [day]="day"
    [ngClass]="classOf(day)"
    (touchend)="select(calendarDay)"></div>
</div>
